module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/s4AKaI/tc-custom/9781439677124.jpg?1704886585333",
      "alt": "This image is the cover for the book Tennessee Legends and Lore, American Legends"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tennessee Legends and Lore, American Legends\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Spooky Side of the Volunteer State Tennessee is steeped in legend. From strange sightings to odd and macabre crimes, the Volunteer State is no stranger to lore. Author Alan Brown details the haunts, troubling crimes and spooky past.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dr. Alan N. Brown\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Alan Brown teaches English at the University of West Alabama in Livingston, Alabama. Alan has written primarily about southern ghost lore, a passion that has taken him to haunted places throughout the entire Deep South, as well as parts of the Midwest and the Southwest. Alan's wife, Marilyn, accompanies him on these trips and occasionally serves as his \"ghost magnet.\" Her encounters with the spirit world have been incorporated in a number of Alan's books.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0